import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class BixiTableService {
  updateView$ = new Subject<string>();

  forceUpdate(tableId: string = '') {
    this.updateView$.next(tableId);
  }
}
